import { getColumnsList } from '@/features/AudienceManager/services';
export const fetchColumnsList = () => {
    return getColumnsList()
        .then(response => formatValue(response?.data))
        .catch(error => {
        console.error('Failed to fetch columns list:', error);
        return formatValue(undefined);
    });
};
const formatValue = (response) => {
    const sortedColumns = Object.values(response?.data?.columns ?? {})
        .filter(column => column.key !== 'pmweb_id')
        .sort((a, b) => a.name.localeCompare(b.name));
    return {
        columns: sortedColumns,
        success: response?.success,
    };
};
